<ng-container>
  @if (isManageEmployeesEnabled$ | async) {
  <div class="myaccount-employee-wrapper">
    @if (itemCount !== undefined) {
    <h2>
      {{ 'myAccount.manageEmployees' | cxTranslate }}
    </h2>
    } @if (itemCount > 0) {
    <div class="myaccount-sort-edit">
      <app-sorting
        [sortOptions]="sortOptions"
        [sortLabels]="sortLabels | async"
        (sortListEvent)="sortChange($event)"
        [selectedOption]="sort"
      >
      </app-sorting>
      <div class="myaccount-edit">
        <a [routerLink]="'add-employee'"
          ><mat-icon class="material-icons-sharp light add-employee">add</mat-icon
          >{{ 'myAccount.addEmployee' | cxTranslate }}</a
        >
      </div>
    </div>
    } @if (itemCount > 0 && isDesktop) {
    <div class="myaccount-table-wrapper">
      <app-table [columns]="columns" [dataSource]="dataSource" [pageSize]="10" [paginator]="null"> </app-table>
    </div>
    } @if (itemCount > 0 && !isDesktop) { @if (managementEmployees$ | async; as managementEmployees) { @for (employee of
    managementEmployees.entries; track employee) {
    <div class="myaccount-tablet-mobile">
      <div class="divider-tablet">
        <div class="divider1">
          <div class="myaccount-fname-wrapper">
            <p class="label">{{ 'myAccount.firstName' | cxTranslate }}</p>
            <p class="data">{{ employee?.firstName }}</p>
          </div>
          <div class="myaccount-lname-wrapper">
            <p class="label">{{ 'myAccount.lastName' | cxTranslate }}</p>
            <p class="data">{{ employee?.lastName }}</p>
          </div>
        </div>
        <div class="divider2">
          <div class="myaccount-email-wrapper">
            <p class="label">{{ 'myAccount.emailAddress' | cxTranslate }}</p>
            <p class="data">{{ employee?.email }}</p>
          </div>
        </div>
      </div>
      <div class="divider-delivery-status">
        <div class="myaccount-delivery-add-wrapper">
          <p class="label">{{ 'myAccount.deliveryAddress' | cxTranslate }}</p>
          @if ((showAddressName$ | async) && employee?.defaultAddress?.addressName) {
          <p class="data">
            <span class="address-name">{{ employee?.defaultAddress?.addressName }}: </span
            >{{ employee?.defaultAddress?.formattedAddress }}
          </p>
          } @else {
          <p class="data">{{ employee?.defaultAddress?.formattedAddress }}</p>
          }
        </div>
        <div class="myaccount-status-wrapper">
          <p class="label">{{ 'myAccount.status' | cxTranslate }}</p>
          <p>
            <span class="inactive-status" [ngClass]="{ 'active-status': employee?.active === true }">{{
              employee?.active ? ('myAccount.active' | cxTranslate) : ('myAccount.inactive' | cxTranslate)
            }}</span>
          </p>
        </div>
      </div>
      <button
        (click)="
          onClickEdit(
            employee?.active,
            employee?.lastName,
            employee?.firstName,
            employee?.email,
            employee?.jobTitle,
            employee?.defaultAddress?.id,
            employee?.defaultAddress?.formattedAddress,
            employee?.uid,
            employee?.storeFrontPermissions
          )
        "
        class="btn-edit-employee"
        mat-button
        [routerLink]="'/my-account/edit-employee'"
      >
        <mat-icon class="material-icons-sharp light add-employee">create</mat-icon>
      </button>
    </div>
    } } } @if (itemCount > 0) {
    <div id="pagination-wrapper-component">
      <app-pagination
        (viewPageEvent)="pageChange($event)"
        [pagination]="PaginationModel"
        [hideOnSinglePage]="true"
      ></app-pagination>
    </div>
    } @if (itemCount === 0) {
    <div class="myaccount-sort-edit no-record-add">
      <div class="myaccount-edit">
        <a [routerLink]="'add-employee'"
          ><mat-icon class="material-icons-sharp light add-employee">add</mat-icon
          >{{ 'myAccount.addEmployee' | cxTranslate }}</a
        >
      </div>
    </div>
    } @if (itemCount === 0) {
    <p class="myaccount-no-records">{{ 'myAccount.noRecords' | cxTranslate }}</p>
    }
  </div>
  }
</ng-container>
